<template>
  <div class="not-found-page page-shell">
    <section class="not-found-card modern-card">
      <div class="status-badge">404</div>
      <h1>页面暂时无法访问</h1>
      <p>
        你访问的页面不存在、链接已调整，或当前资源已经下线。可以返回首页继续查看课程、案例和帮助信息。
      </p>
      <div class="action-row">
        <el-button type="primary" icon="el-icon-s-home" @click="$router.replace('/home')">
          返回首页
        </el-button>
        <el-button icon="el-icon-arrow-left" @click="$router.go(-1)">
          返回上一页
        </el-button>
        <el-button icon="el-icon-question" @click="$router.replace('/help')">
          查看帮助中心
        </el-button>
      </div>
      <div class="support-line">
        如需技术支持，请联系平台管理员或北京数字维尔科技有限公司服务人员。
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped lang="scss">
.not-found-page {
  min-height: calc(100vh - 78px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
}

.not-found-card {
  width: min(760px, 100%);
  padding: 54px 48px;
  text-align: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  margin-bottom: 24px;
  border-radius: 28px;
  background: linear-gradient(135deg, rgba(47, 111, 237, 0.12), rgba(244, 104, 36, 0.12));
  color: var(--primary-color);
  font-size: 30px;
  font-weight: 900;
}

h1 {
  margin: 0 0 16px;
  color: var(--brand-blue-deep);
  font-size: 34px;
  font-weight: 900;
}

p {
  max-width: 560px;
  margin: 0 auto;
  color: var(--gray-text);
  font-size: 16px;
  line-height: 1.8;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 30px;
}

.support-line {
  margin-top: 28px;
  padding-top: 22px;
  border-top: 1px solid rgba(226, 232, 240, 0.85);
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.7;
}

@media screen and (max-width: 640px) {
  .not-found-page {
    padding: 48px 18px;
  }

  .not-found-card {
    padding: 40px 22px;
  }

  .status-badge {
    width: 76px;
    height: 76px;
    border-radius: 22px;
    font-size: 26px;
  }

  h1 {
    font-size: 26px;
  }

  .action-row {
    flex-direction: column;
  }

  .action-row .el-button {
    width: 100%;
    margin-left: 0 !important;
  }
}
</style>
